import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageComponent } from './components/page/page.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { LayoutComponent } from './components/layout/layout.component';
import { PreviewComponent } from './components/preview/preview.component';

const routes: Routes = [
  // Public routes (no AuthGuard, no Layout)
  /** User access routes have been deprecated. All content is now public for all users. */
  // { path: 'login', canActivate: [UserGuard], component: LoginComponent },
  // {
  //   path: 'request',
  //   canActivate: [UserGuard],
  //   loadComponent: () => import('./components/user/request/request.component').then(m => m.RequestComponent)
  // },
  // {
  //   path: 'password',
  //   canActivate: [UserGuard],
  //   loadComponent: () => import('./components/user/password/password.component').then(m => m.PasswordComponent)
  // },
  
  // Preview handler route - PUBLIC (validates and redirects)
  {
    path: 'api/preview',
    component: PreviewComponent
  },

  // Main layout wrapper
  {
    path: '',
    component: LayoutComponent,
    children: [
      // PUBLIC Preview route (has layout, no AuthGuard)
      {
        path: 'preview/:slug',
        loadComponent: () => import('./components/page/page.component').then(m => m.PageComponent),
        data: { isPreview: true } 
      },

      // PROTECTED routes (with AuthGuard)
      { 
        path: '', 
        loadComponent: () =>
          import('./components/page/page.component').then(m => m.PageComponent),
        data: { slug: 'home' } 
      },
      {
        path: 'docs/:slug',
        loadComponent: () => import('./components/page/page.component').then(m => m.PageComponent)
      },
      { 
        path: 'docs', 
        loadComponent: () =>
          import('./components/page/page.component').then(m => m.PageComponent),
        data: { slug: 'docs-home' } 
      },  
      {
        path: 'p/:slug',
        loadComponent: () => import('./components/page/page.component').then(m => m.PageComponent)
      },
      {
        path: 'support',
        loadComponent: () => import('./components/support/support.component').then(m => m.SupportComponent)
      },
      {
        path: 'e',
        loadChildren: () => import('./modules/endpoint.module').then(m => m.EndpointModule)
      },
      {
        path: 'r',
        loadChildren: () => import('./modules/recipes.module').then(m => m.RecipesModule)
      },
      { path: '**', component: NotFoundComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }